import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { EsimFlowType } from '@/enums/esim';

export const useEsimFlow = () => {
  const { query } = useRouter();

  const esimFlowType = useMemo(() => {
    return query?.id === EsimFlowType.SWAP
      ? EsimFlowType.SWAP
      : EsimFlowType.ESIM;
  }, [query?.id]);

  const isSwapFlow = esimFlowType === EsimFlowType.SWAP;
  const isEsimFlow = esimFlowType === EsimFlowType.ESIM;

  return { esimFlowType, isSwapFlow, isEsimFlow };
};
